import classof from 'shared/utils/classof';
import isLocalStorageAvailable from 'shared/utils/isLocalStorageAvailable';
import queryString from 'query-string';

const locationLocalStorageName = 'storeLocationId';
let storeLocationId = '';

const updateValue = value => {
	const type = classof(value);

	if (type === 'Null') {
		storeLocationId = '';
	} else if (type !== 'String' && type !== 'Number') {
		storeLocationId = isLocalStorageAvailable
			? localStorage.getItem(locationLocalStorageName) || storeLocationId
			: storeLocationId;
	} else {
		storeLocationId = value;
	}

	if (isLocalStorageAvailable) {
		localStorage.setItem(locationLocalStorageName, storeLocationId);
	}
};

export default Object.defineProperties(
	{},
	{
		location: {
			get() {
				storeLocationId = isLocalStorageAvailable
					? localStorage.getItem(locationLocalStorageName) || storeLocationId
					: storeLocationId;

				return storeLocationId;
			},
			set(value) {
				let storeId = null;

				if (classof(value) === 'Object') {
					storeId = queryString.parse(value.router && value.router.location && value.router.location.search).StoreNumber;
					updateValue(storeId);
				} else {
					updateValue(value);
				}
			},
			enumerable: true,
			configurable: false,
		},
	},
);
